import React, { Component } from 'react'
import { FilterParticipantsGrid } from 'containers/filters'
import { ParticipantsGridTable } from 'components/sections/participants'
import { apiConfiguration, apiParticipants } from 'helpers/decorators/api'
import { CONFIGURATION_KEYS } from '../../../constants/enums'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'

import { participants as participantsApi } from '../../../redux/modules/api'


@apiConfiguration({
    getValues: [
        CONFIGURATION_KEYS.enableContactLabels.id,
        CONFIGURATION_KEYS.enableAwardLabels.id
    ]
})
@apiParticipants({
  list: true,
  listGrid: true,
  filter: 'leaderParticipants',
  useCommonLimit: true
})
@connect(
    ({ auth }) => ({
        activeOrganization: auth.organization
    }),
    { setFilter: participantsApi.setParticipantsGridFilter, modal }
)
class LeaderParticipants extends Component {
  render() {
    return (
      <div>
        <FilterParticipantsGrid />
        <ParticipantsGridTable {...this.props} showLastActivity />
      </div>
    )
  }
}

export default LeaderParticipants
